
import { CaseStudyTemplate } from '@/components/case-studies/CaseStudyTemplate';
import { faBell, faVideo, faLink } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function FallDetectionCaseStudy() {
  const { t } = useTranslation();
  return (
    <CaseStudyTemplate
      id="fall"
      title={t('caseStudies.fall.title')}
      description={t('caseStudies.fall.description')}
      video="/Fall.mp4"
      image="/images/case-studies/fall-detection-hero.jpg"
      problem={t('caseStudies.fall.problem')}
        solution={t('caseStudies.fall.solution')}
        results={t('caseStudies.fall.results')}
        features={[
          {
            title: t('caseStudies.fall.features[0].title'),
            description: t('caseStudies.fall.features[0].description'),
            icon: faBell
          },
          {
            title: t('caseStudies.fall.features[1].title'),
            description: t('caseStudies.fall.features[1].description'),
            icon: faVideo
          },
          {
            title: t('caseStudies.fall.features[2].title'),
            description: t('caseStudies.fall.features[2].description'),
            icon: faLink
          }
        ]}
        faqs={t('caseStudies.fall.faq', { returnObjects: true }) as Array<{id?: string, question: string, answer: string}>}
      />
  );
}
